// for administrators only
import AdminPanel from './components/AdminPanel.vue';
import AdminPanelSuggestedChannels from './components/AdminPanelSuggestedChannels.vue';
import AdminPanelInactiveChannels from './components/AdminPanelInactiveChannels.vue';
import AdminPanelSubmissions from './components/AdminPanelSubmissions.vue';
import AdminPanelComments from './components/AdminPanelComments.vue';
import AdminPanelDashboard from './components/AdminPanelDashboard.vue';
import AdminPanelStatistics from './components/AdminPanelStatistics.vue';
import AdminPanelUsers from './components/AdminPanelUsers.vue';
import AdminLocation from './components/Location'

// For moderators only
import ModeratorPanel from './components/ModeratorPanel.vue';

import ModeratorPanelRules from './components/ModeratorPanelRules.vue';
import ModeratorPanelModerators from './components/ModeratorPanelModerators.vue';
import ModeratorPanelBlockDomains from './components/ModeratorPanelBlockDomains.vue';
import ModeratorPanelBanUsers from './components/ModeratorPanelBanUsers.vue';
import ModeratorPanelReportedComments from './components/ModeratorPanelReportedComments.vue';
import ModeratorPanelReportedSubmissions from './components/ModeratorPanelReportedSubmissions.vue';
import ChannelSettings from './components/ChannelSettings.vue';
import SignUp from './components/auth/SignUp.vue';
import Login from './components/auth/Login.vue';

// static pages
import Rules from './components/pages/Rules.vue';
import TermsOfService from './components/pages/TermsOfService.vue';
import PrivacyPolicy from './components/pages/PrivacyPolicy.vue';
import About from './components/pages/About.vue';
import Credits from './components/pages/Credits.vue';

import BookmarkedChannels from './components/BookmarkedChannels.vue';
import SubmissionRedirector from './components/SubmissionRedirector.vue';
import ChannelSubmissions from './components/ChannelSubmissions.vue';
import BookmarkedComments from './components/BookmarkedComments.vue';
import BookmarkedUsers from './components/BookmarkedUsers.vue';
import UserSubmissions from './components/UserSubmissions.vue';
import FindChannels from './components/FindChannels.vue';
import SubmissionPage from './components/SubmissionPage.vue';
import UserComments from './components/UserComments.vue';
import Bookmarks from './components/Bookmarks.vue';
import NotFound from './components/NotFound.vue';
//import Home from './components/Home.vue';
import Subscribed from './components/Subscribed.vue';
import Newsworthy from './components/Newsworthy.vue';
import Channel from './components/Channel.vue';
import UserPage from './components/UserPage.vue';
import DeletedSubmissionPage from './components/DeletedSubmissionPage.vue';
import BookmarkedSubmissions from './components/BookmarkedSubmissions.vue';
import UserLikedSubmissions from './components/UserLikedSubmissions.vue';
import SubscribedChannels from './components/SubscribedChannels.vue';
import Location from './components/LocationComponent.vue';
import HumTogSubmission from './components/submission/HumTogSubmission.vue';


// new
import ModeratorIndex from "./pages/moderators/Index";
import ModeratorDashboard from './pages/moderators/Dashboard';
import ModeratorSubmissions from './pages/moderators/Submissions';
import ModeratorComments from './pages/moderators/Comments';

const routes = [
    {
        name: 'home',
        path: '/',
        component: Subscribed
    },
    /*{
        name: 'subscribed',
        path: '/subscribed',
        component: Subscribed
    },*/
    {
        name: 'location',
        path: '/l/:name',
        component: Location,
    },
    {
        name: 'newsworthy',
        path: '/newsworthy',
        component: Newsworthy,
    },
    {
        name: 'HumTogSubmission',
        path: '/new-submission',
        component: HumTogSubmission,
        props: true
    },
    {
        name: 'HumTogSubmissionEdit',
        path: '/edit-submission/:slug',
        component: HumTogSubmission,
    },
    {
        path: '/signup',
        component: SignUp,
        meta: { title: 'SignUp' }
    },
    {
        path: '/signin',
        component: Login,
        meta: { title: 'SignIn' }
    },

    {
        path: '/tos',
        component: TermsOfService,
        meta: { title: 'Terms Of Service' }
    },

    {
        path: '/rules',
        component: Rules,
        meta: { title: 'Rules' }
    },

    {
        path: '/privacy-policy',
        component: PrivacyPolicy,
        meta: { title: 'Privacy Policy' }
    },
    { path: '/about', component: About, meta: { title: 'About' } },
    { path: '/credits', component: Credits, meta: { title: 'Credits' } },
    {
        path: '/subscriptions',
        component: SubscribedChannels,
        name: 'subscriptions',
        meta: { title: 'My Subscriptions' }
    },

    {
        path: '/big-daddy',
        component: AdminPanel,
        beforeEnter(to, from, next) {
            axios.post('/admin/check').then((response) => {
                if (response.data == true) {
                    next();
                }

                router.push({
                    to: '/'
                })
                // next(false);
            });
        },
        children: [
            {
                path: '',
                component: AdminPanelDashboard,
                name: 'admin-panel-dashboard'
            },
            {
                path: 'location',
                component: AdminLocation,
                name: 'location-management'
            },
            {
                path: 'statistics',
                component: AdminPanelStatistics,
                name: 'admin-panel-statistics'
            },
            {
                path: 'users',
                component: AdminPanelUsers,
                name: 'admin-panel-users'
            },
            {
                path: 'submissions',
                component: AdminPanelSubmissions,
                name: 'admin-panel-submissions'
            },
            {
                path: 'comments',
                component: AdminPanelComments,
                name: 'admin-panel-comments'
            },
            {
                path: 'channels/suggested',
                component: AdminPanelSuggestedChannels,
                name: 'admin-panel-suggested-channels'
            },
            {
                path: 'channels/inactive',
                component: AdminPanelInactiveChannels,
                name: 'admin-panel-inactive-channels'
            }
        ]
    },

    {
        path: '/@:username',
        component: UserPage,
        children: [
            { path: '', component: UserSubmissions, name: 'user-submissions' },
            {
                path: 'comments',
                component: UserComments,
                name: 'user-comments'
            },
            {
                path: 'liked-submissions',
                component: UserLikedSubmissions,
                name: 'user-likes'
            }
        ]
    },

    {
        path: '/c/:name/mod/reports',
        redirect: '/c/:name/mod/ban-users'
    },
    { path: '/c/:name/mod', redirect: '/c/:name/mod/ban-users' },
    {
        path: '/c/:name',
        component: Channel,
        children: [
            {
                path: '',
                component: ChannelSubmissions,
                name: 'channel-submissions'
            },
            {
                path: 'mod',
                component: ModeratorPanel,
                children: [
                    /*{
                        path: 'reports/submissions',
                        name: 'moderator-panel-reported-submissions',
                        component: ModeratorPanelReportedSubmissions,
                        meta: { title: 'Reports | Submissions' }
                    },
                    {
                        path: 'reports/comments',
                        name: 'moderator-panel-reported-comments',
                        component: ModeratorPanelReportedComments,
                        meta: { title: 'Reports | Comments' }
                    },*/
                    {
                        path: 'ban-users',
                        name: 'moderator-panel-ban-users',
                        component: ModeratorPanelBanUsers,
                        meta: { title: 'Ban Users | Moderator Panel' }
                    },
                    {
                        path: 'block-domains',
                        name: 'moderator-panel-block-domains',
                        component: ModeratorPanelBlockDomains,
                        meta: { title: 'Block Domains | Moderator Panel' }
                    },
                    {
                        path: 'rules',
                        name: 'moderator-panel-rules',
                        component: ModeratorPanelRules,
                        meta: { title: 'Rules | Moderator Panel' }
                    },
                    {
                        path: 'manage-moderators',
                        name: 'moderator-panel-manage-moderators',
                        component: ModeratorPanelModerators,
                        meta: { title: 'Manage Moderators | Moderator Panel' }
                    },
                    {
                        path: 'manage-users',
                        name: 'moderator-panel-manage-users',
                        component: ModeratorPanelUsers,
                        meta: { title: 'Manage Users | User Panel' }
                    },
                    {
                        path: 'settings',
                        name: 'channel-settings',
                        component: ChannelSettings,
                        meta: { title: 'Settings | Moderator Panel' }
                    }
                ]
            }
        ]
    },

    { path: '/deleted-submission', component: DeletedSubmissionPage },
    { path: '/submission/:id', component: SubmissionRedirector },
    {
        path: '/discover-channels',
        component: FindChannels,
        name: 'discover-channels',
        meta: { title: 'Discover Channels' }
    },
    {
        path: '/404',
        component: NotFound,
        name: 'not-found',
        meta: { title: 'Not Found' }
    },
    {
        path: '/c/:name/:slug',
        component: SubmissionPage,
        name: 'submission-page'
    },
    {
        path: '/p/:slug',
        component: SubmissionPage,
        name: 'submission-page-new'
    },

    { path: '/bookmarks', redirect: '/bookmarks/submissions' },
    {
        name: 'bookmarks',
        path: '/bookmarks',
        component: Bookmarks,
        children: [
            {
                path: 'submissions',
                component: BookmarkedSubmissions,
                name: 'bookmarked-submissions',
                meta: { title: 'Submissions | Bookmarks' }
            },
            {
                path: 'comments',
                component: BookmarkedComments,
                name: 'bookmarked-comments',
                meta: { title: 'Comments | Bookmarks' }
            },
            {
                path: 'channels',
                component: BookmarkedChannels,
                name: 'bookmarked-channels',
                meta: { title: 'Channels | Bookmarks' }
            },
            {
                path: 'users',
                component: BookmarkedUsers,
                name: 'bookmarked-users',
                meta: { title: 'Users | Bookmarks' }
            }
        ]
    },
    { path: '/home', redirect: '/' },
    { path: '*', component: NotFound, meta: { title: 'Not Found' } },

    //new
    {
        path: '/moderator',
        component: ModeratorIndex,
        children: [
            {
                path: '',
                component: ModeratorDashboard,
                name: 'moderator-dashboard'
            },
            {
                path: 'submissions',
                component: ModeratorSubmissions,
                name: 'moderator-submissions'
            },
            {
                path: 'comments',
                component: ModeratorComments,
                name: 'moderator-comments'
            }
        ]
    },
];

import VueRouter from 'vue-router';
import ModeratorPanelUsers from './components/ModeratorPanelUsers'
Vue.use(VueRouter);

var router = new VueRouter({
    mode: 'history',
    routes
});

// scroll behavior
const scrollableElementId = 'submissions';
const scrollPositions = Object.create(null);

/**
 * Fills the <title> tag with the right value before navigating to the
 * new route.First it checks the title in the meta, if it exists it
 * sets it to that, otherwise sets it to the default (Humtog).
 */
router.beforeEach((to, from, next) => {
    // scroll behavior
    let element = document.getElementById(scrollableElementId);

    if (element !== null) {
        scrollPositions[from.name] = element.scrollTop;
    }

    // page title
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        if (
            to.name != 'submission-page' &&
            to.name != 'submission-page-new' &&
            to.name != 'channel' &&
            to.name != 'home' &&
            to.name != 'user-submissions' &&
            to.name != 'user-comments'
        ) {
            document.title = 'Humtog';
        }
    }

    next();
});

// scroll behavior
window.addEventListener('popstate', () => {
    let currentRouteName = router.history.current.name;

    let element = document.getElementById(scrollableElementId);

    if (element !== null && currentRouteName in scrollPositions) {
        setTimeout(
            () => (element.scrollTop = scrollPositions[currentRouteName]),
            50
        );
    }
});

/**
 * Since Google Analytics's default tracking code doesn't play nice with
 * single-page-applications, we're gonna use this one. What it does
 * is simply running after navigating to each new route.
 */
router.afterEach((to, from) => {
    if (Laravel.env == 'production') {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            (i[r] =
                i[r] ||
                function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }),
                (i[r].l = 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(
            window,
            document,
            'script',
            'https://www.google-analytics.com/analytics.js',
            'ga'
        );

        ga('create', 'UA-116656785-1', 'auto');

        ga('set', 'page', to.path);
        ga('send', 'pageview');
    }
});

export default router;



// WEBPACK FOOTER //
// ./resources/assets/js/routes.js